import React from 'react';
import { ResponsiveLine } from '@nivo/line';
import { max, sum, rollup, ticks } from 'd3-array';
import { format } from 'd3-format';
import { timeFormat } from 'd3-time-format';
import { Classes } from "@blueprintjs/core";
import './NivoBarChart.scss';


const NivoLineChart = ({ features, aggProp, colorProp, color, filterProp }) => {
  const fString = aggProp.toLowerCase().includes('cost') ? '$.2s' : ',d';
  const skeletonClass = features.length === 0 ? Classes.SKELETON : '';
  const agg = fs => sum(fs, f => f.properties[aggProp]);
  const key1 = f => f.properties[colorProp] || "" // remove nulls
  const key2 = f => f.properties.NIVO_TIME || ""; // remove nulls

  const sortByKey = (a, b) => {
    if (a.x < b.x) return -1;
    if (a.x > b.x) return 1;
    return 0;
  }

  // make nivo format
  const rolled = rollup(features, agg, key1, key2);
  const data = Array.from(rolled, ([id, timeMap]) => {
    return {
      id, color: color(id), data: (Array.from(timeMap, ([x, y]) => ({ x, y })).sort(sortByKey))
        .map(({ x, y }) => ({ x: timeFormat("%Y-%m-%d")(x), y }))
    }
  })
  const yMax = max(data
    .filter(c => !filterProp || filterProp === c.id)
    .map(c => max(c.data.map(d => d.y))));

  return (
    <>
      <h5
        className={["bp3-heading", "bp3-text-overflow-ellipsis", skeletonClass].join(' ')}
        style={{ padding: '6px', margin: 0, marginTop: 12 }}
      >
        Monthly Totals
      </h5>
      <div className={skeletonClass}
        style={{ height: 220, overflow: 'hidden' }}>
        <ResponsiveLine
          data={data}
          curve={'monotoneX'}
          margin={{ top: 6, right: 6, bottom: 50, left: 45 }}
          colors={r => {
            if (!filterProp || filterProp === r.id) return r.color;
            return '#d5d5d580';
          }}
          lineWidth={1}
          pointSize={6}
          // pointColor={'white'}
          // pointBorderWidth={4}
          // pointBorderColor={{
          //   from: 'serieColor',
          //   modifiers: [
          //     ['opacity', .2]
          //   ]
          // }}
          enableGridX={false}
          axisTop={null}
          yScale={{
            type: 'linear',
            max: yMax
            // stacked: boolean('stacked', true),
          }}
          axisLeft={{
            format: value => format(fString)(value),
            tickValues: ticks(0, yMax, 7)
          }}

          xScale={{
            type: 'time',
            format: '%Y-%m-%d',
            precision: 'month',
          }}
          xFormat="time:%Y-%m-%d"
          axisBottom={{
            format: '%b %Y',
            tickValues: 'every 2 months',
            tickRotation: -30
          }}

          animate={true}
          useMesh={true}
          enableSlices="x"
          sliceTooltip={({ slice }) => {
            return (
              <div
                style={{
                  background: 'white',
                  border: '1px solid #ccc',
                }}
              >
                {slice.points.map(point => (
                  <div
                    key={point.id}
                    style={{
                      color: point.serieColor,
                      padding: '0',
                    }}
                  >
                    <strong>{point.serieId}:</strong> {format(fString)(point.data.y)}
                  </div>
                ))}
              </div>
            )
          }}
          tooltip={({ point: { data: { xFormatted, y } } }) => `${xFormatted} ${format(fString)(y)}`}
        />
      </div>
    </>
  )
}

export default NivoLineChart;